import { create } from 'zustand'
import { AdDecision, AdLoadStatus } from '../utils/adBlockDetect'

interface IAdBlockStore {
  imaStatus: AdLoadStatus | null
  /** null = pending (detection not finished yet for the current page) */
  decision: AdDecision | null
  adblock: boolean
  setResult: (result: { imaStatus: AdLoadStatus; decision: AdDecision }) => void
}

export const useAdBlockStore = create<IAdBlockStore>()(set => ({
  imaStatus: null,
  decision: null,
  adblock: false,
  setResult: ({ imaStatus, decision }) =>
    set({ imaStatus, decision, adblock: decision === 'block' }),
}))
